// import Vue from 'vue'
// const service = new Vue

export const widgetList = (v) => [
  {
    label: v.$t('page_resource_pool_input'),
    value: 'INPUT'
  },
  {
    label: v.$t('page_resource_pool_ninput'),
    value: 'INPUTNUMBER'
  },
  {
    label: v.$t('page_resource_pool_switch'),
    value: 'SWITCH'
  },
  {
    label: v.$t('page_resource_pool_date'),
    value: 'DATE'
  },
  {
    label: v.$t('page_resource_pool_select'),
    value: 'SELECT'
  }
]
// [UPLOAD, CHECKBOX, SWITCH, INPUT, RADIO, SELECT, DATE, INPUTNUMBER, TREESELECT]